var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"t-table-v2__cell__primary"},[_c('strong',[_vm._v(_vm._s(_vm.user.fullname))])]),_vm._v(" "),_c('div',{staticClass:"t-table-v2__cell__secondary"},[_vm._v("\n    "+_vm._s(_vm.user.email)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }